import { render, staticRenderFns } from "./editPart.vue?vue&type=template&id=38fa5b4b&scoped=true"
import script from "./editPart.vue?vue&type=script&lang=js"
export * from "./editPart.vue?vue&type=script&lang=js"
import style0 from "./editPart.vue?vue&type=style&index=0&id=38fa5b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa5b4b",
  null
  
)

export default component.exports